import { EyeCheckOutlineIcon } from './EyeCheckOutlineIcon';

/**
 * author: Austin Andrews
 * id A2829948-6FFA-48BB-B387-959A7E3658DE
 * name eye-check-outline
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eye-check-outline.svg
 * tags
 */
export const EyeTickOutlineIcon = EyeCheckOutlineIcon;
export default EyeTickOutlineIcon